<p-card *ngIf="allSurveys">
  <div class="p-card-title">
    Ratings Criteria
    <tooltip-button
      tooltip="Attendees can leave private feedback on each criterion you add below. To present a criterion to attendees, turn its ‘Display’ toggle ON. Note: Deleting a criterion will also delete all collected responses. To keep past responses, it’s safer to just turn off ‘Display’ instead of deleting."
    ></tooltip-button>
  </div>

  <div *ngFor="let survey of allSurveys" class="p-mt-3">
    <div class="p-d-flex p-jc-between">
      {{ survey.name | uppercase }}
      <p-inputSwitch
        id="surveySwitch"
        [(ngModel)]="survey.isVisible"
        (onChange)="toggleSurvey(survey)"
      ></p-inputSwitch>
    </div>
    <br />
    <div class="input-container">
      <div class="input-cell">
        <label>Add Criteria</label>
        <span class="input-flex inline-input">
          <input
            type="text"
            pInputText
            class="complete-input"
            placeholder="Add Criteria"
            [(ngModel)]="survey.newRatingCriteria"
            (keyup.enter)="submitNewCriteria(survey); (false)"
          />
          <button
            *ngIf="survey.newRatingCriteria"
            pButton
            class="p-button-primary"
            type="button"
            label="CREATE"
            (click)="submitNewCriteria(survey); (false)"
          ></button>
        </span>
      </div>
    </div>

    <div class="p-grid p-my-3">
      <div class="input-container p-md-8 p-col-12">
        <div class="input-cell">
          <label>NAME</label>
        </div>
      </div>
      <div class="input-container p-md-3 p-col-12">
        <div class="input-cell">
          <label>DISPLAY</label>
        </div>
      </div>
      <div class="input-container p-md-1 p-col-12">
        <div class="input-cell">
          <label>&nbsp;</label>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>

    <div
      class="list-item p-grid fg-seperator-list p-nogutter p-my-3"
      *ngFor="let question of survey.questions; let i = index"
    >
      <div class="input-container p-md-8 p-col-12">
        <div class="input-cell">
          <input
            pInputText
            [name]="'question-name' + i"
            type="text"
            [(ngModel)]="question.name"
            [disabled]="!question.isEditable"
            (change)="updateQuestion(survey.id, { id: question.id, name: question.name })"
          />
        </div>
      </div>
      <div class="input-container p-md-3 p-col-8">
        <div class="input-cell inline-toggle">
          <p-inputSwitch
            [(ngModel)]="question.isVisible"
            (onChange)="
              updateQuestion(survey.id, { id: question.id, isVisible: question.isVisible })
            "
          ></p-inputSwitch>
        </div>
      </div>
      <div class="p-col-4 p-md-1 p-ai-center p-grid p-jc-center">
        <i
          class="pi pi-times remove-icon"
          [style.opacity]="question.canDelete ? null : '.25'"
          [style.cursor]="question.canDelete ? 'pointer' : 'inherit'"
          (click)="question.canDelete && deleteQuestion(survey, question)"
        ></i>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
  <div *ngIf="!allSurveys?.length">No Records Found</div>
  <div class="clearfix"></div>
</p-card>
